import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setPageSetting, EnumHtmlContent, savepdfStatement, getPADAgreement, getCoverLetterHtmlData, getBeneficiaryFormHtmlData, downloadFinishedEnrollmentFile } from "../../actions";
import { CoverageComponent } from "../../components";
import { RootState } from "../../reducers";
import { ObjectUtils } from "../../utils";
import _ from "underscore";
import { ContentDataConstants, navigateChangedState, REPORT_TYPES } from "../../constants";

const DEFAULT_FILENAMES = {
  BENEFICIARY_FORM: 'BeneficiaryForm',
  ESIGN_FORM: 'BeneficiaryESignForm',
  COVER_LETTER: 'CoverLetter',
  PAD_AGREEMENT: 'PADAgreement'
};

export const ViewHtmlReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reportType: any = searchParams.get('reportType') ?? -1;
  const param: any = searchParams.get('param') ?? -1;
  const source = searchParams.get('source');
  const contentMainMenu = useSelector((state: RootState) => state.common.screens || [{}]);
  const { reportHtmlContent } = useSelector((state: RootState) => state.common || null);
  const contentFooter = useSelector((state: RootState) => state.common.contentFooter);
  const [htmlContent, sethtmlContent] = useState<EnumHtmlContent | null>(null);
  const { pageSetting } = useSelector((state: RootState) => state.event);
  const beneficiariyForm = useSelector((state: RootState) => state.beneficiary.beneficiariyForm || {});
  const footerContent = contentFooter?.contentResource?.contents;
  const backButtonText = ObjectUtils.extractLabelFromObject(footerContent || {}, "btnBack");

  const handleClick = useCallback(() => {
    if (htmlContent) {
      if (reportType === REPORT_TYPES.PAD_AGREEMENT) {
        savepdfStatement(htmlContent.buttonSavePDF?.btnNavigateTo, DEFAULT_FILENAMES.PAD_AGREEMENT);
      }
      else {
        let downloadFilename = "";
        if (reportType === REPORT_TYPES.BENEFICIARY_FORM) {
          if (param === "true")
            downloadFilename = beneficiariyForm?.beneficiaryESign?.fileName ? beneficiariyForm?.beneficiaryESign?.fileName : DEFAULT_FILENAMES.ESIGN_FORM;
          else
            downloadFilename = beneficiariyForm?.beneficiaryForms?.fileName ? beneficiariyForm?.beneficiaryForms?.fileName : DEFAULT_FILENAMES.BENEFICIARY_FORM;
        }
        else {
          downloadFilename = DEFAULT_FILENAMES.COVER_LETTER;
        }
        downloadFinishedEnrollmentFile(htmlContent.buttonSavePDF?.btnNavigateTo, downloadFilename);
      }
    }
  }, [htmlContent, reportType, beneficiariyForm, param]); 

  useEffect(() => {
    if (!reportHtmlContent) {
      if (reportType === REPORT_TYPES.PAD_AGREEMENT) {
        dispatch(getPADAgreement());
      } else if (reportType === REPORT_TYPES.EOI_FORM) {
        dispatch(getCoverLetterHtmlData(param));
      } else {
        dispatch(getBeneficiaryFormHtmlData(source ? `${param}&source=${encodeURIComponent(source)}` : param));
      }
    } else {
      sethtmlContent(reportHtmlContent);
    }
  }, [dispatch, reportHtmlContent, reportType, param, source]);

  useEffect(() => {
    // clear on unmount so the next report is always fetched, not served stale
    return () => {
      dispatch({
        type: ContentDataConstants.GET_REPORT_HTML_CONTENT,
        payload: null
      });
    };
  }, [dispatch]);

  const previousPage = () => {
    if (localStorage.getItem('pageName')) {
      const menuItem = _.find(contentMainMenu, item => item.name === localStorage.getItem('pageName'))
      setPageSetting(localStorage.getItem('pageName'));
      localStorage.removeItem('pageName')
      navigate(`/${menuItem ? menuItem.link : ""}`);
    } else
      pageSetting.link ? navigate(`/${pageSetting.link}`) : navigate("/", navigateChangedState)

  };

  const buttonInput = [
    htmlContent?.buttonSavePDF && {
      type: "submit",
      className: "secondary btn-submit float-end",
      display: htmlContent?.buttonSavePDF?.display,
      onSubmit: handleClick
    }
  ];

  const buttonBack = [
    backButtonText?.display && {
      display: backButtonText.display,
      variant: "link",
      rightpos: true,
      displayclass: "m-0 mx-3",
      className: "float-left",
      icon: faChevronLeft,
      onSubmit: previousPage
    }
  ];
  return <> {htmlContent ? <CoverageComponent buttonInput={buttonInput} buttonBack={buttonBack} coverageData={htmlContent} disclaimerText={htmlContent?.disclaimer} reportType={1} /> : null}</>;
};

export default ViewHtmlReport;
